import React, { createContext, useContext, useMemo, useState } from 'react';

type ContentRefetchContextValue = {
	refetchContent: boolean;
};

type ContentRefetchDispatchContextValue = {
	setRefetchContent: (shouldRefetchContent: boolean) => void;
};

export const ContentRefetchContext = createContext<ContentRefetchContextValue>({
	refetchContent: false,
});
ContentRefetchContext.displayName = 'ContentRefetchContext';

export const ContentRefetchDispatchContext = createContext<ContentRefetchDispatchContextValue>({
	setRefetchContent: () => {},
});
ContentRefetchDispatchContext.displayName = 'ContentRefetchDispatchContext';

export const ContentRefetchProvider = ({ children }) => {
	const [refetchContent, setRefetchContent] = useState<boolean>(false);

	const providerValue = useMemo(
		() => ({
			refetchContent,
		}),
		[refetchContent],
	);

	const dispatchProviderValue = useMemo(
		() => ({
			setRefetchContent: (shouldRefetchContent: boolean) => setRefetchContent(shouldRefetchContent),
		}),
		[setRefetchContent],
	);

	return (
		<ContentRefetchContext.Provider value={providerValue}>
			<ContentRefetchDispatchContext.Provider value={dispatchProviderValue}>
				{children}
			</ContentRefetchDispatchContext.Provider>
		</ContentRefetchContext.Provider>
	);
};

export const useContentRefetch = () => useContext(ContentRefetchContext);
export const useContentRefetchDispatch = () => useContext(ContentRefetchDispatchContext);
